module.exports = __webpack_public_path__ + "static/assets/ee794e2ca3982b5f1c17675973b5bb71.svg";